<template>
    <div id="history">
        <div class="head-tool">
            <span @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
            <span class="tc">
                <button class="l" :class="{active : active == 2}" @click="active=2">我的书架</button>
                <button class="r" :class="{active : active == 1}" @click="active=1">最近阅读</button>
            </span>
            <span class="tr" @click="$router.push('/')">首页</span>
        </div>

        <ul v-show="active==2" v-infinite-scroll="getCollection">
            <router-link :to="{name:'Book',params:{wid:val.wid}}" tag="li" v-for="val in collection">
                <el-image :src="'http://static.yuread.cn/'+ val.h_cover + '@!thumb'" class="fl">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
                <div class="fl info">
                    <h4>{{val.title}}
                        <span class="fr"  @click.stop="doCollection(val.wid)">移除书架</span>
                    </h4>
                    <p class="author">{{val.author}}</p>
                </div>
            </router-link>
        </ul>

        <ul v-show="active==1" v-infinite-scroll="getHistory">
            <router-link :to="{name:'Book',params:{wid:val.wid}}" tag="li" v-for="val in history">
                <el-image :src="'http://static.yuread.cn/'+ val.h_cover + '@!thumb'" class="fl">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
                <div class="fl info">
                    <h4>{{val.title}}
                        <router-link class="fr" :to="{name:'Chapter',params: {wid:val.wid,cid:val.cid}}" v-if="active == 1">继续阅读</router-link>
                        <span class="fr"  v-if="active == 2" @click.stop="doCollection(val.wid)">移除书架</span>
                    </h4>
                    <p class="author">{{val.author}}</p>
                    <router-link tag="p" class="chap" :to="{name:'Chapter',params: {wid:val.wid,cid:val.curr.id}}" v-if="active == 1">阅读至 - {{val.curr.title}}</router-link>
                    <router-link tag="p" class="chap" :to="{name:'Chapter',params: {wid:val.wid,cid:val.last.id}}" v-if="active == 1">
                        <span v-if="val.is_finish">已完结</span>
                        <span v-else>更新至</span>
                        - {{val.last.title}}
                    </router-link>
                </div>
            </router-link>
        </ul>

    </div>
</template>

<script>
    export default {
        name: "History",
        data(){
            return {
                active:this.$route.query.active || 1,
                history : [],
                collection : [],
                historyPage : 1,
                historyLimit : 10,
                historyLast : 1,
                collectionPage : 1,
                collectionLimit : 10,
                collectionLast : 1,
                isloading :true,
                isloading1 : true,
            }
        },
        computed : {

        },
        methods : {
            getHistory() {
                if(this.historyPage <= this.historyLast && this.isloading){
                    this.isloading = false;
                    this.axios.post('/api/readlog/getReadlog',{
                        page : this.historyPage,
                        limit : this.historyLimit
                    }).then(r =>{
                        this.historyPage++;
                        this.isloading = true;
                        if(r.data.code == 1){
                            this.historyLast = r.data.data.last_page
                            r.data.data.data.forEach(v => {
                                this.history.push(v);
                            })
                        }
                    })
                }

            },
            getCollection(){
                if(this.collectionPage <= this.collectionLast && this.isloading1){
                    this.isloading1 = false;
                    this.axios.post('/api/collection/getCollectionlist',{
                        page : this.collectionPage,
                        limit : this.collectionLimit
                    }).then(r=>{
                        this.isloading1 = true;
                        this.collectionPage++;
                        if(r.data.code == 1){
                            this.collectionLast = r.data.data.last_page;
                            r.data.data.data.forEach(v => {
                                this.collection.push(v);
                            })
                        }
                    })
                }

            },
            doCollection(bookid){
                if(confirm("确认要移除书架吗？") == true){
                    this.axios.post('/api/collection/doCollection',{
                        bid :bookid,
                        type : 0,
                    }).then(r => {
                        let data = r.data;
                        this.getCollection();
                    })
                }

            }
        },
        created(){
        }

    }
</script>

<style lang="less">
    #history{background: #f6f6f7;height: 100%;
        .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
            span{flex:1;font-size: 30px;color:#333;
                i{font-size: 30px;}
            }
            .tc{flex-basis: 250px;
                .l{border-radius: 6px 0 0 6px;}
                .r{border-radius: 0 6px 6px 0;}
                button{border:1px solid @theme;background: #fff;padding: 0px 10px;font-size: 26px;color: @theme;}
                .active{background: @theme;color:#fff;}
            }
        }

        ul{overflow: auto;background: #fff;height: calc(100% - 100px);
            li{padding:20px;overflow: auto;border-bottom:1px solid #efefef;
                .el-image{width:120px;height:168px;}
                .info{width: calc(100% - 130px);
                    padding: 20px 0 0 20px;
                    h4{font-size: 30px;font-weight: 400;color:#333;
                        span,a{color:#b2b2b2;font-size: 28px;}
                    }
                    .author{color:#b2b2b2;font-size: 28px;}
                    .tr{color:#6e6e6e;font-size: 26px;}
                }

                .chap{font-size: 24px;color: #666;}
            }
        }
    }
</style>
